import React, { useState } from 'react';
import { PostHogProvider } from 'posthog-js/react';
import {
    getAnalyticsConsent,
    setAnalyticsConsent
} from '../analytics';
import './AnalyticsConsent.css';

const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const analyticsProperties = {
    app: 'lickbefore',
    app_label: 'Lick Before You Stick',
    environment: process.env.NODE_ENV === 'production' ? 'production' : 'development',
    analytics_schema_version: 1
};
const posthogOptions = {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    ui_host: 'https://us.posthog.com',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: false,
    disable_session_recording: true,
    disable_external_dependency_loading: true,
    advanced_disable_flags: true,
    person_profiles: 'never',
    persistence: 'localStorage',
    respect_dnt: true,
    before_send: (event) => event ? ({
        ...event,
        properties: {
            ...event.properties,
            ...analyticsProperties
        }
    }) : event,
    loaded: (client) => {
        client.register(analyticsProperties);
    }
};

const AnalyticsConsent = ({ children }) => {
    const [consent, setConsent] = useState(() => getAnalyticsConsent());
    const [showPreferences, setShowPreferences] = useState(() => getAnalyticsConsent() === null);

    const updateConsent = (nextConsent) => {
        setAnalyticsConsent(nextConsent);
        setConsent(nextConsent);
        setShowPreferences(false);
    };

    const content = consent === 'granted' && posthogKey ? (
        <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
            {children}
        </PostHogProvider>
    ) : children;

    return (
        <>
            {content}

            {showPreferences && (
                <section
                    className="analytics-consent"
                    role="dialog"
                    aria-modal="false"
                    aria-labelledby="analytics-consent-title"
                >
                    <div className="analytics-consent-copy">
                        <p className="analytics-consent-kicker">Privacy choice</p>
                        <h2 id="analytics-consent-title">Help improve the experience?</h2>
                        <p>
                            Allow anonymous page and product-usage analytics. We do not record
                            searches, video titles, session replays, or account details.
                        </p>
                    </div>
                    <div className="analytics-consent-actions">
                        <button
                            type="button"
                            className="analytics-consent-button analytics-consent-button-secondary"
                            onClick={() => updateConsent('denied')}
                        >
                            Decline
                        </button>
                        <button
                            type="button"
                            className="analytics-consent-button analytics-consent-button-primary"
                            onClick={() => updateConsent('granted')}
                        >
                            Allow anonymous analytics
                        </button>
                    </div>
                </section>
            )}
        </>
    );
};

export default AnalyticsConsent;
